import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { ToasterService } from 'angular2-toaster';
import 'rxjs/add/operator/toPromise';

import { NewPurchaseReturnModel } from '../model/index';

@Injectable()
export class NewPurchaseReturnService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private newPurchaseReturnUrl = 'api/newPurchaseReturn';  // URL to web api

    constructor(private http: Http, public toasterService: ToasterService) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }


    getNewPurchaseReturnList(query: any): Promise<NewPurchaseReturnModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.newPurchaseReturnUrl}/getNewPurchaseReturnList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getNewPurchaseReturnDetails(query: any): Promise<NewPurchaseReturnModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.newPurchaseReturnUrl}/getNewPurchaseReturnDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getAvailableSerialNumbers(query: any): Promise<NewPurchaseReturnModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.newPurchaseReturnUrl}/getAvailableSerialNumbers`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getModelDetails(query: any): Promise<NewPurchaseReturnModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.newPurchaseReturnUrl}/getModelDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    addReturnItem(query: any): Promise<NewPurchaseReturnModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.newPurchaseReturnUrl}/addReturnItem`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    addUpdateNewPurchaseReturnEntry(data: any): Promise<NewPurchaseReturnModel> {
        const url = `${this.newPurchaseReturnUrl}/addUpdateNewPurchaseReturnEntry`;
        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as NewPurchaseReturnModel)
            .catch(this.handleError);
    }

    deleteNewPurchaseReturnEntry(rowData: any): Promise<NewPurchaseReturnModel> {
        const url = `${this.newPurchaseReturnUrl}/deleteNewPurchaseReturnEntry`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as NewPurchaseReturnModel)
            .catch(this.handleError);
    }

    updateCreditNote(rowData: any): Promise<NewPurchaseReturnModel> {
        const url = `${this.newPurchaseReturnUrl}/updateCreditNote`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as NewPurchaseReturnModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/newPurchaseReturn.service.ts